export default __webpack_public_path__ + "static/media/select-file.728d4ccf.svg";